import { useTranslation } from 'react-i18next';
import type { ModifierKeys } from 'styled-components-modifiers';

// Import styles
import { Content, RequiredMark } from './styles';

type Props = {
	label: string | JSX.Element | JSX.Element[];
	required?: boolean;
	isError?: boolean;
	modifiers?: ModifierKeys | undefined;
	indented?: boolean;
	showIsOptional?: boolean;
};

export const CheckboxContent = ({ label, isError, required, modifiers, indented = false, showIsOptional = false }: Props) => {
	const { t } = useTranslation();

	if (required && isError) {
		return (
			<Content modifiers={modifiers} indented={indented}>
				<RequiredMark modifiers={modifiers}>{t('agreement_required')}</RequiredMark> {label}
			</Content>
		);
	} else if (!required && showIsOptional) {
		return (
			<Content modifiers={modifiers} indented={indented}>
				<RequiredMark isOptional modifiers={modifiers}>
					{t('agreement_optional')}
				</RequiredMark>
				{label}
			</Content>
		);
	} else {
		return (
			<Content modifiers={modifiers} indented={indented}>
				{label}
			</Content>
		);
	}
};
